import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackOption = ({ id, text, selected, onChange }) => {
    return (_jsxs("div", { className: "radiobuttons-stacked-card-item", children: [_jsx("input", { required: true, type: "radio", id: `feedbackType${id}`, name: "feedbackType", checked: selected === id, onChange: () => onChange(id) }), _jsx("label", { htmlFor: `feedbackType${id}`, style: { lineHeight: '1' }, children: text })] }));
};
export default FeedbackOption;
